import http from "../requestBase";

/**
 * @typedef {import('lodash')} _
 */
import _ from "lodash";

const API_BASE = "api/Surveys";

function lockSurvey(id) {
  return new Promise((resolve, reject) => {
    http
      .patch(`API_BASE/${id}/Lock`, { Lock: true })
      .then((response) => {
        if (response.Error) {
          reject("Backendmsg:" + response.Error);
        }
        resolve(response);
      })
      .catch((err) => reject(err));
  });
}

function deleteByID(id) {
  return new Promise((resolve, reject) => {
    http
      .delete(`${API_BASE}/${id}`)
      .then((response) => {
        if (response.Error) {
          reject("Backendmsg:" + response.Error);
        }
        resolve(response);
      })
      .catch((err) => reject(err));
  });
}

function getByID(id) {
  return new Promise((resolve, reject) => {
    http
      .get(`${API_BASE}/${id}`)
      .then((response) => {
        if (response.Error) {
          reject("Backendmsg:" + response.Error);
        }
        resolve(response);
      })
      .catch((err) => reject(err));
  });
}

function exportByID(id) {
  var queryString = `${API_BASE}/${id}/Export`;
  return new Promise((resolve, reject) => {
    http
      .get(`${API_BASE}/${id}/Export`)
      .then((response) => {
        if (response.Error) {
          reject("Backendmsg:" + response.Error);
        }
        resolve(response);
      })
      .catch((err) => reject(err));
  });
}

/**
 *
 * @param {Object} filterStrings Contains the Columms as key and the filter as values
 * @param {Number} pageSize Items per page
 * @param {Number} selectedPage The Selected Field
 * @param {String} sortField The Field to sort by
 * @param {('asc'|'desc')} [sortOrder]  Sort order
 * @returns {Promise}
 */
function getAll(
  filterStrings = {},
  pageSize = 20,
  selectedPage = 1,
  sortField = "SurveyTitle",
  sortOrder = "asc"
) {
  let queryString = `${API_BASE}/Get?page_size=${pageSize}&page=${selectedPage}&sort_column=${sortField}&sort_order=${sortOrder}`;
  queryString = encodeURI(queryString);

  //TODO: validate Filter and trim
  let Filter = _.isEmpty(filterStrings) ? "" : filterStrings;

  return new Promise((resolve, reject) => {
    http
      .post(queryString, { Filter })
      .then((response) => {
        if (response.Error) {
          reject("Backendmsg:" + response.Error);
        }
        resolve(response);
      })
      .catch((err) => reject(err));
  });
}

function create(content) {
  var queryString = `${API_BASE}`;
  return new Promise((resolve, reject) => {
    http
      .post(queryString, content)
      .then((response) => {
        if (response.Error) {
          reject("Backendmsg:" + response.Error);
        }
        resolve(response);
      })
      .catch((err) => reject(err));
  });
}

function update(id, content) {
  return http.put(`${API_BASE}/${id}`, content);
}

function getCustomPropertiesByID(id) {
  return new Promise((resolve, reject) => {
    http
      .get(`${API_BASE}/${id}/CustomProperties`)
      .then((response) => {
        if (response.Error) {
          reject("Backendmsg:" + response.Error);
        }
        resolve(response);
      })
      .catch((err) => reject(err));
  });
}
let UseSurvey = {
  getAll,
  getByID,
  create,
  update,
  lockSurvey,
  deleteByID,
  exportByID,
  getCustomPropertiesByID,
};

export default UseSurvey;



// WEBPACK FOOTER //
// ./src/services/Surveys/index.js